<script>
import { useEsignStore } from '../../stores/esign'
import { useFormValidation } from '../../composables/useFormValidation'
import EcInput from '../ui/EcInput.vue'
import EcSelect from '../ui/EcSelect.vue'
import EcComboSelect from '../ui/EcComboSelect.vue'
import EcCheckbox from '../ui/EcCheckbox.vue'
import EcButton from '../ui/EcButton.vue'
import EcAlert from '../ui/EcAlert.vue'
import EcErrorBanner from '../ui/EcErrorBanner.vue'
import EcSpinner from '../ui/EcSpinner.vue'
import TemplateSelector from './TemplateSelector.vue'

var languageOptions = [
  { value: 'en', label: 'Anglais (États-Unis)' },
  { value: 'da', label: 'Danois' },
  { value: 'de', label: 'Allemand' },
  { value: 'en-GB', label: 'Anglais (Royaume-Uni)' },
  { value: 'es', label: 'Espagnol (Amérique latine)' },
  { value: 'es-ES', label: 'Espagnol (Espagne)' },
  { value: 'fr', label: 'Français' },
  { value: 'it', label: 'Italien' },
  { value: 'nl', label: 'Néerlandais' },
  { value: 'no', label: 'Norvégien' },
  { value: 'pl', label: 'Polonais' },
  { value: 'pt', label: 'Portugais' },
  { value: 'ro', label: 'Roumain' },
  { value: 'bg', label: 'Bulgare' },
  { value: 'ru', label: 'Russe' },
  { value: 'zh-CN', label: 'Chinois simplifié' },
  { value: 'zh-TW', label: 'Chinois traditionnel' },
  { value: 'ja', label: 'Japonais' },
  { value: 'ko', label: 'Coréen' },
  { value: 'el', label: 'Grec' },
  { value: 'ar', label: 'Arabe' },
]

var timezoneOptions = [
  { value: 'Etc/GMT+12', label: '(GMT-12:00) GMT-12' },
  { value: 'Pacific/Samoa', label: '(GMT-11:00) Pacifique/Samoa' },
  { value: 'HST', label: '(GMT-10:00) Hawaï' },
  { value: 'Pacific/Honolulu', label: '(GMT-10:00) Pacifique/Honolulu' },
  { value: 'US/Alaska', label: '(GMT-9:00) États-Unis/Alaska' },
  { value: 'America/Los_Angeles', label: '(GMT-8:00) Amérique/Los Angeles' },
  { value: 'America/Tijuana', label: '(GMT-8:00) Amérique/Tijuana' },
  { value: 'Canada/Pacific', label: '(GMT-8:00) Canada/Pacifique' },
  { value: 'PST', label: '(GMT-8:00) Pacifique' },
  { value: 'America/Vancouver', label: '(GMT-8:00) Amérique/Vancouver' },
  { value: 'America/Denver', label: '(GMT-7:00) Amérique/Denver' },
  { value: 'Canada/Mountain', label: '(GMT-7:00) Canada/Montagnes' },
  { value: 'America/Phoenix', label: '(GMT-7:00) Amérique/Phoenix' },
  { value: 'CST', label: '(GMT-6:00) Centre' },
  { value: 'Canada/Central', label: '(GMT-6:00) Canada/Centre' },
  { value: 'US/Central', label: '(GMT-6:00) États-Unis/Centre' },
  { value: 'America/Regina', label: '(GMT-6:00) Amérique/Regina' },
  { value: 'America/Chicago', label: '(GMT-6:00) Amérique/Chicago' },
  { value: 'America/Bogota', label: '(GMT-5:00) Amérique/Bogota' },
  { value: 'America/Toronto', label: '(GMT-5:00) Amérique/Toronto' },
  { value: 'EST', label: '(GMT-5:00) Est' },
  { value: 'US/Eastern', label: '(GMT-5:00) États-Unis/Est' },
  { value: 'America/Detroit', label: '(GMT-5:00) Amérique/Détroit' },
  { value: 'America/Montreal', label: '(GMT-5:00) Amérique/Montréal' },
  { value: 'America/Panama', label: '(GMT-5:00) Amérique/Panama' },
  { value: 'America/Caracas', label: '(GMT-4:30) Amérique/Caracas' },
  { value: 'America/Puerto_Rico', label: '(GMT-4:00) Amérique/Porto Rico' },
  { value: 'Canada/Atlantic', label: '(GMT-4:00) Canada/Atlantique' },
  { value: 'America/Santiago', label: '(GMT-4:00) Amérique/Santiago' },
  { value: 'America/St_Johns', label: '(GMT-3:30) Amérique/Saint-Jean' },
  { value: 'Canada/Newfoundland', label: '(GMT-3:30) Canada/Terre-Neuve' },
  { value: 'America/Argentina/Buenos_Aires', label: '(GMT-3:00) Argentine/Buenos Aires' },
  { value: 'Brazil/East', label: '(GMT-3:00) Brésil/Est' },
  { value: 'Atlantic/Azores', label: '(GMT-1:00) Atlantique/Açores' },
  { value: 'Atlantic/Cape_Verde', label: '(GMT-1:00) Atlantique/Cap-Vert' },
  { value: 'Africa/Casablanca', label: '(GMT 0:00) Afrique/Casablanca' },
  { value: 'GMT', label: '(GMT 0:00) Greenwich' },
  { value: 'Europe/London', label: '(GMT 0:00) Europe/Londres' },
  { value: 'Africa/Lagos', label: '(GMT+1:00) Afrique/Lagos' },
  { value: 'CET', label: '(GMT+1:00) Europe centrale' },
  { value: 'Europe/Paris', label: '(GMT+1:00) Europe/Paris' },
  { value: 'Europe/Zurich', label: '(GMT+1:00) Europe/Zurich' },
  { value: 'Europe/Amsterdam', label: '(GMT+1:00) Europe/Amsterdam' },
  { value: 'Europe/Madrid', label: '(GMT+1:00) Europe/Madrid' },
  { value: 'Europe/Rome', label: '(GMT+1:00) Europe/Rome' },
  { value: 'Europe/Stockholm', label: '(GMT+1:00) Europe/Stockholm' },
  { value: 'Europe/Warsaw', label: '(GMT+1:00) Europe/Varsovie' },
  { value: 'Africa/Cairo', label: '(GMT+2:00) Afrique/Le Caire' },
  { value: 'Asia/Istanbul', label: '(GMT+2:00) Asie/Istanbul' },
  { value: 'Europe/Helsinki', label: '(GMT+2:00) Europe/Helsinki' },
  { value: 'Africa/Nairobi', label: '(GMT+3:00) Afrique/Nairobi' },
  { value: 'Asia/Tehran', label: '(GMT+3:30) Asie/Téhéran' },
  { value: 'Asia/Dubai', label: '(GMT+4:00) Asie/Dubaï' },
  { value: 'Europe/Moscow', label: '(GMT+4:00) Europe/Moscou' },
  { value: 'Asia/Kabul', label: '(GMT+4:30) Asie/Kaboul' },
  { value: 'Asia/Karachi', label: '(GMT+5:00) Asie/Karachi' },
  { value: 'Asia/Kolkata', label: '(GMT+5:30) Asie/Kolkata' },
  { value: 'Asia/Dhaka', label: '(GMT+6:00) Asie/Dhaka' },
  { value: 'Asia/Bangkok', label: '(GMT+7:00) Asie/Bangkok' },
  { value: 'Asia/Jakarta', label: '(GMT+7:00) Asie/Jakarta' },
  { value: 'Asia/Hong_Kong', label: '(GMT+8:00) Asie/Hong Kong' },
  { value: 'Australia/Perth', label: '(GMT+8:00) Australie/Perth' },
  { value: 'Asia/Seoul', label: '(GMT+9:00) Asie/Séoul' },
  { value: 'Asia/Tokyo', label: '(GMT+9:00) Asie/Tokyo' },
  { value: 'Australia/Adelaide', label: '(GMT+9:30) Australie/Adélaïde' },
  { value: 'Australia/Darwin', label: '(GMT+9:30) Australie/Darwin' },
  { value: 'Australia/Brisbane', label: '(GMT+10:00) Australie/Brisbane' },
  { value: 'Australia/Sydney', label: '(GMT+10:00) Australie/Sydney' },
  { value: 'Asia/Vladivostok', label: '(GMT+11:00) Asie/Vladivostok' },
  { value: 'Pacific/Auckland', label: '(GMT+12:00) Pacifique/Auckland' },
  { value: 'Pacific/Tongatapu', label: '(GMT+13:00) Pacifique/Tongatapu' },
]

function createEmptySigner() {
  return { role: '', email: '', first_name: '', last_name: '', address: '' }
}

export default {
  name: 'SignatureForm',
  components: {
    EcInput,
    EcSelect,
    EcComboSelect,
    EcCheckbox,
    EcButton,
    EcAlert,
    EcErrorBanner,
    EcSpinner,
    TemplateSelector,
  },
  props: {
    signableType: {
      type: String,
      required: true,
    },
    signableId: {
      type: [String, Number],
      required: true,
    },
    signature: {
      type: Object,
      default: null,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    submitError: {
      type: String,
      default: null,
    },
  },
  data() {
    var store = useEsignStore()
    var validation = useFormValidation()

    var form = {
      name: '',
      description: '',
      email_message: '',
      meta: {
        language: 'fr',
        timezone: 'GMT',
      },
      signers: [createEmptySigner()],
      use_template: false,
      template_id: null,
      model_code: null,
      documents: [],
      fields: [],
      send_immediately: false,
    }

    var usingOneSpanModel = false

    // Populate form when editing an existing signature
    if (this.signature) {
      form.name = this.signature.name || ''
      form.description = this.signature.description || ''
      form.email_message = this.signature.email_message || ''
      form.meta = {
        language: (this.signature.meta && this.signature.meta.language) || 'fr',
        timezone: (this.signature.meta && this.signature.meta.timezone) || 'GMT',
      }

      if (this.signature.model_id) {
        form.use_template = true
        form.template_id = this.signature.model_id
        usingOneSpanModel = true
      }

      // Populate signers from flat array (API format)
      if (this.signature.signers && this.signature.signers.length) {
        form.signers = this.signature.signers
          .filter(function (s) { return s.email })
          .map(function (s) {
            return {
              role: s.role || '',
              email: s.email || '',
              first_name: s.firstname || s.first_name || '',
              last_name: s.lastname || s.last_name || '',
              address: s.address || '',
            }
          })
      } else if (this.signature.roles && this.signature.roles.length) {
        form.signers = this.signature.roles.flatMap(function (role) {
          return role.signers.map(function (s) {
            return {
              role: role.name,
              email: s.email,
              first_name: s.first_name || s.firstname || '',
              last_name: s.last_name || s.lastname || '',
              address: s.address || '',
            }
          })
        })
      }

      if (!form.signers.length) {
        form.signers = [createEmptySigner()]
      }
    }

    return {
      store: store,
      validation: validation,
      form: form,
      usingOneSpanModel: usingOneSpanModel,
      rawTemplateFields: [],
      clientErrors: {},
      defaultRoles: [
        { code: 'CUSTOMER', label: 'Client' },
        { code: 'OTHER', label: 'Autre' },
      ],
      mappingSigners: {},
      languageOptions: languageOptions,
      timezoneOptions: timezoneOptions,
    }
  },
  computed: {
    t() {
      return this.$ecTranslate
    },
    isEditMode() {
      return !!this.signature
    },
    disableTemplateSelection() {
      return this.isEditMode || !!(this.signature && this.signature.token)
    },
    roleOptions() {
      var options = this.defaultRoles.map(function (r) { return { value: r.code, label: r.label } })
      var self = this
      // Add roles from mapping signers that aren't already in the list
      Object.keys(this.mappingSigners).forEach(function (role) {
        if (!options.some(function (o) { return o.value === role })) {
          options.push({ value: role, label: role })
        }
      })
      // Add roles from current signers that aren't already in the list
      this.form.signers.forEach(function (signer) {
        if (signer.role && !options.some(function (o) { return o.value === signer.role })) {
          options.push({ value: signer.role, label: signer.role })
        }
      })
      return options
    },
    hasFields() {
      return this.form.use_template && this.form.fields.length > 0
    },
    showSendNow() {
      return !this.isEditMode && this.usingOneSpanModel
    },
    canModifySigners() {
      return !this.form.use_template && !this.usingOneSpanModel
    },
  },
  watch: {
    'form.use_template': function (checked) {
      if (!checked) {
        this.form.template_id = null
        this.form.model_code = null
        this.form.documents = []
        this.form.fields = []
        this.rawTemplateFields = []
        this.form.signers = [createEmptySigner()]
        this.form.name = ''
        this.form.description = ''
        this.form.email_message = ''
        this.usingOneSpanModel = false
      }
    },
    'form.signers': {
      deep: true,
      handler: function () {
        this.clearSignerErrors()
      },
    },
    'form.fields': {
      deep: true,
      handler: function () {
        var clientErrors = this.clientErrors
        Object.keys(clientErrors).forEach(function (key) {
          if (key.startsWith('fields.')) {
            delete clientErrors[key]
          }
        })
      },
    },
    submitError: function (val) {
      if (val) this.scrollFormToTop()
    },
  },
  async mounted() {
    // Load default data (roles) and signable-mapper signers in parallel
    var results = await Promise.allSettled([
      this.store.fetchDefaultData({}),
      this.store.fetchSigners(this.signableType, this.signableId),
    ])

    if (results[0].status === 'fulfilled' && results[0].value && results[0].value.roles && results[0].value.roles.length) {
      this.defaultRoles = results[0].value.roles
    }

    // Build mapping signers lookup by role
    var signersData = this.store.signers
    if (signersData && typeof signersData === 'object' && !Array.isArray(signersData)) {
      this.mappingSigners = signersData
    } else if (Array.isArray(signersData) && signersData.length) {
      var map = {}
      signersData.forEach(function (s) {
        if (s.role) map[s.role] = s
      })
      this.mappingSigners = map
    }
  },
  methods: {
    onTemplateSelected(template) {
      this.usingOneSpanModel = template.token != null
      this.form.template_id = template.id
      this.form.model_code = template.code || null
      this.form.name = template.name || this.form.name
      this.form.description = template.excerpt || template.description || this.form.description
      this.form.email_message = template.email_message || this.form.email_message

      // Reset signers and fields
      this.form.signers = []
      this.form.fields = []
      this.rawTemplateFields = []

      // Copy fields from template
      if (template.fields && template.fields.length) {
        this.rawTemplateFields = JSON.parse(JSON.stringify(template.fields))

        var first = template.fields[0]
        if (first.approvals) {
          this.form.fields = []
          for (var d = 0; d < template.fields.length; d++) {
            var doc = template.fields[d]
            var approvals = doc.approvals || []
            for (var a = 0; a < approvals.length; a++) {
              var fields = approvals[a].fields || []
              for (var fi = 0; fi < fields.length; fi++) {
                var field = fields[fi]
                if (!field.name && !field.tooltip) continue
                this.form.fields.push({
                  code: field.name || field.id || '',
                  label: field.tooltip || field.name || '',
                  value: field.subtype === 'CHECKBOX' ? (field.value === true || field.value === 'true' || field.value === 'x') : (field.value || ''),
                  document_id: doc.document_id,
                  required: !!field.required,
                  subtype: field.subtype || 'TEXTFIELD',
                  options: field.options || [],
                  groupTooltip: field.groupTooltip,
                })
              }
            }
          }
        } else {
          this.form.fields = template.fields.map(function (f) {
            var entry = {
              code: f.code || f.name || '',
              label: f.label || f.code || '',
              value: f.subtype === 'CHECKBOX' ? (f.value === true || f.value === 'true' || f.value === 'x') : (f.value || ''),
              required: !!f.required,
              subtype: f.subtype || 'TEXTFIELD',
              options: f.options || [],
              groupTooltip: f.groupTooltip,
            }
            if (f.document_id) entry.document_id = f.document_id
            return entry
          })
        }
      }

      // Populate signers from template
      var self = this
      if (template.signers && template.signers.length) {
        template.signers.forEach(function (signer) {
          var role = signer.role || ''
          var mapped = self.mappingSigners[role]
          self.form.signers.push({
            role: role,
            email: signer.email || (mapped && mapped.email) || '',
            first_name: signer.firstname || signer.first_name || (mapped && mapped.firstname) || '',
            last_name: signer.lastname || signer.last_name || (mapped && mapped.lastname) || '',
            address: signer.address || (mapped && mapped.address) || '',
          })
        })
      } else if (template.roles && template.roles.length) {
        template.roles.forEach(function (role) {
          var roleName = typeof role === 'string' ? role : role.name
          var mapped = self.mappingSigners[roleName]
          if (typeof role === 'object' && role.signers && role.signers.length) {
            role.signers.forEach(function (signer) {
              self.form.signers.push({
                role: roleName,
                email: signer.email || (mapped && mapped.email) || '',
                first_name: signer.firstname || signer.first_name || (mapped && mapped.firstname) || '',
                last_name: signer.lastname || signer.last_name || (mapped && mapped.lastname) || '',
                address: signer.address || (mapped && mapped.address) || '',
              })
            })
          } else {
            self.form.signers.push({
              role: roleName,
              email: (mapped && mapped.email) || '',
              first_name: (mapped && mapped.firstname) || '',
              last_name: (mapped && mapped.lastname) || '',
              address: (mapped && mapped.address) || '',
            })
          }
        })
      }

      if (!this.form.signers.length) {
        this.form.signers = [createEmptySigner()]
      }

      // Populate documents from template
      if (template.documents && template.documents.length) {
        this.form.documents = template.documents.map(function (doc) {
          return {
            id: doc.id,
            name: doc.name,
            originalName: doc.name,
            url: doc.url,
            replacementFile: null,
            replacementFileName: null,
            replacementBase64: null,
          }
        })
      } else {
        this.form.documents = []
      }

      // Copy meta
      var meta = template.meta
      if (meta) {
        this.form.meta = {
          language: meta.language || this.form.meta.language,
          timezone: meta.timezone || this.form.meta.timezone,
        }
      }
    },
    addSigner() {
      var roleKey = this.form.signers.length + 1
      var roleObj = this.defaultRoles[roleKey - 1]
      var role = roleObj ? roleObj.code : 'SIGNATAIRE_0' + roleKey
      var mapped = this.mappingSigners[role]
      this.form.signers.push({
        role: role,
        email: (mapped && mapped.email) || '',
        first_name: (mapped && mapped.firstname) || '',
        last_name: (mapped && mapped.lastname) || '',
        address: (mapped && mapped.address) || '',
      })
    },
    removeSigner(index) {
      if (this.form.signers.length > 1) {
        this.form.signers.splice(index, 1)
      }
    },
    onRoleChange(signer) {
      var mapped = this.mappingSigners[signer.role]
      signer.first_name = (mapped && mapped.firstname) || ''
      signer.last_name = (mapped && mapped.lastname) || ''
      signer.email = (mapped && mapped.email) || ''
      signer.address = (mapped && mapped.address) || ''
    },
    readFileAsBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader()
        reader.onload = function () {
          var result = reader.result
          var base64 = result.split(',')[1] || result
          resolve(base64)
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    async onDocumentReplace(index, event) {
      var input = event.target
      var file = input.files && input.files[0]
      if (!file) return

      this.form.documents[index].replacementFile = file
      this.form.documents[index].replacementFileName = file.name
      this.form.documents[index].replacementBase64 = await this.readFileAsBase64(file)
    },
    removeReplacement(index) {
      this.form.documents[index].replacementFile = null
      this.form.documents[index].replacementFileName = null
      this.form.documents[index].replacementBase64 = null
    },
    validate() {
      var t = this.$ecTranslate
      this.clientErrors = {}

      if (!this.form.name.trim()) {
        this.$set(this.clientErrors, 'name', t('ELIXIO_CONNECT.NAME_REQUIRED'))
      }

      if (this.form.use_template && !this.form.template_id) {
        this.$set(this.clientErrors, 'template', t('ELIXIO_CONNECT.MODEL_REQUIRED'))
      }

      // Validate each signer's fields
      var self = this
      this.form.signers.forEach(function (signer, index) {
        if (!signer.role.trim()) {
          self.$set(self.clientErrors, 'signers.' + index + '.role', t('ELIXIO_CONNECT.ROLE_REQUIRED'))
        }
        if (!signer.email.trim()) {
          self.$set(self.clientErrors, 'signers.' + index + '.email', t('ELIXIO_CONNECT.EMAIL_REQUIRED'))
        }
        if (!signer.first_name.trim()) {
          self.$set(self.clientErrors, 'signers.' + index + '.first_name', t('ELIXIO_CONNECT.FIRSTNAME_REQUIRED'))
        }
        if (!signer.last_name.trim()) {
          self.$set(self.clientErrors, 'signers.' + index + '.last_name', t('ELIXIO_CONNECT.LASTNAME_REQUIRED'))
        }
      })

      // Validate required template fields
      this.form.fields.forEach(function (field, index) {
        if (field.required) {
          var val = field.value
          if (field.subtype === 'CHECKBOX') {
            if (!val) {
              self.$set(self.clientErrors, 'fields.' + index + '.value', t('ELIXIO_CONNECT.FIELD_REQUIRED'))
            }
          } else if (typeof val === 'string' && !val.trim()) {
            self.$set(self.clientErrors, 'fields.' + index + '.value', t('ELIXIO_CONNECT.FIELD_REQUIRED'))
          } else if (val == null || val === '') {
            self.$set(self.clientErrors, 'fields.' + index + '.value', t('ELIXIO_CONNECT.FIELD_REQUIRED'))
          }
        }
      })

      // Validate radio groups
      var radioGroups = this.getRadioGroups(this.form.fields)
      radioGroups.forEach(function (group) {
        if (!group.selected) {
          var firstField = group.fields[0]
          var fieldIndex = self.form.fields.findIndex(function (f) { return f.code === firstField.code })
          if (fieldIndex >= 0) {
            self.$set(self.clientErrors, 'fields.' + fieldIndex + '.value', t('ELIXIO_CONNECT.FIELD_REQUIRED'))
          }
        }
      })

      // Validate unique roles
      var roles = this.form.signers.map(function (s) { return s.role }).filter(Boolean)
      var duplicates = roles.filter(function (r, i) { return roles.indexOf(r) !== i })
      if (duplicates.length) {
        this.$set(this.clientErrors, 'roles', t('ELIXIO_CONNECT.ROLE_MUST_BE_UNIQUE'))
      }

      var hasErrors = Object.keys(this.clientErrors).length > 0
      if (hasErrors) {
        this.scrollFormToTop()
      }
      return !hasErrors
    },
    scrollFormToTop() {
      var self = this
      this.$nextTick(function () {
        if (self.$refs.formEl) {
          self.$refs.formEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },
    getError(field) {
      return this.clientErrors[field] || this.validation.getFieldError(field) || undefined
    },
    clearSignerErrors() {
      var self = this
      Object.keys(this.clientErrors).forEach(function (key) {
        if (key.startsWith('signers.')) {
          self.$delete(self.clientErrors, key)
        }
      })
    },
    getFieldsByType(subtype) {
      return this.form.fields.filter(function (f) { return f.subtype === subtype })
    },
    getNonRadioFields() {
      return this.form.fields.filter(function (f) { return f.subtype !== 'RADIO' })
    },
    getRadioGroups(fields) {
      var groups = {}
      fields.forEach(function (field) {
        if (field.subtype !== 'RADIO' || !field.options || !field.options.length) return
        var groupKey = field.options[0]
        if (!groups[groupKey]) {
          groups[groupKey] = {
            groupTooltip: field.groupTooltip || 'Choisissez une option',
            selected: null,
            fields: [],
          }
        }
        groups[groupKey].fields.push(field)
        if (field.value === 'x') {
          groups[groupKey].selected = field.code
        }
      })
      return Object.values(groups)
    },
    handleRadioChange(group, selectedCode) {
      group.selected = selectedCode
      group.fields.forEach(function (field) {
        field.value = field.code === selectedCode ? 'x' : ''
      })
    },
    fieldIndex(field) {
      return this.form.fields.findIndex(function (f) { return f.code === field.code })
    },
    async onSubmit() {
      this.validation.resetApiValidation()

      if (!this.validate()) return

      // If we have raw template fields, sync edited values back into the nested structure
      if (this.rawTemplateFields.length) {
        for (var fi = 0; fi < this.form.fields.length; fi++) {
          var flatField = this.form.fields[fi]
          for (var d = 0; d < this.rawTemplateFields.length; d++) {
            var doc = this.rawTemplateFields[d]
            var approvals = doc.approvals || []
            for (var a = 0; a < approvals.length; a++) {
              var fields = approvals[a].fields || []
              for (var f = 0; f < fields.length; f++) {
                var field = fields[f]
                var fieldCode = field.name || field.id || ''
                if (fieldCode === flatField.code) {
                  if (flatField.subtype === 'CHECKBOX') {
                    field.value = flatField.value ? 'x' : null
                  } else {
                    field.value = flatField.value
                  }
                }
              }
            }
          }
        }
      }

      this.$emit('submitted', Object.assign({}, this.form, { rawTemplateFields: this.rawTemplateFields }))
    },
    onCancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<template>
  <form ref="formEl" @submit.prevent="onSubmit" novalidate>
    <!-- Global API / submit errors -->
    <EcErrorBanner v-if="submitError" :error="submitError" class="ec-mb-3" />
    <EcErrorBanner v-if="validation.apiGlobalErrors.length" :errors="validation.apiGlobalErrors" class="ec-mb-3" />

    <!-- Section 1: Template Selection (create mode only) -->
    <div v-if="!isEditMode" class="ec-mb-3">
      <EcCheckbox
        :value="form.use_template"
        :label="t('ELIXIO_CONNECT.FROM_MODEL')"
        :disabled="disableTemplateSelection"
        @input="form.use_template = $event"
      />

      <div v-if="form.use_template" class="ec-mt-2">
        <label class="ec-form-label">{{ t('ELIXIO_CONNECT.SELECT_MODEL') }}</label>
        <TemplateSelector
          :value="form.template_id"
          :holder-type="signableType"
          :holder-id="signableId"
          :disabled="disableTemplateSelection"
          @input="form.template_id = $event"
          @template-selected="onTemplateSelected"
        />
        <div v-if="getError('template')" class="ec-form-error ec-mt-1">
          {{ getError('template') }}
        </div>
      </div>
    </div>

    <hr v-if="!isEditMode" style="border-color: var(--ec-border-color, #e2e8f0); margin: 1rem 0" />

    <!-- Section 2: Basic Info -->
    <div class="ec-mb-3">
      <EcInput
        :value="form.name"
        :label="`${t('ELIXIO_CONNECT.NAME')} (*)`"
        :placeholder="t('ELIXIO_CONNECT.NAME')"
        required
        :error="getError('name')"
        @input="form.name = $event"
      />
    </div>

    <!-- Language & Timezone -->
    <div class="ec-form-row ec-mb-3">
      <div class="ec-form-row__col">
        <EcSelect
          :value="form.meta.language"
          :label="t('ELIXIO_CONNECT.LANGUAGE')"
          :options="languageOptions"
          @input="form.meta.language = $event"
        />
      </div>
      <div class="ec-form-row__col">
        <EcSelect
          :value="form.meta.timezone"
          :label="t('ELIXIO_CONNECT.TIMEZONE')"
          :options="timezoneOptions"
          @input="form.meta.timezone = $event"
        />
      </div>
    </div>

    <!-- Description -->
    <div class="ec-form-group ec-mb-3">
      <label class="ec-form-label">{{ t('ELIXIO_CONNECT.EXCERPT') }}</label>
      <textarea
        v-model="form.description"
        class="ec-textarea"
        rows="3"
        :placeholder="t('ELIXIO_CONNECT.EXCERPT')"
      />
    </div>

    <!-- Email Message -->
    <div class="ec-form-group ec-mb-3">
      <label class="ec-form-label">{{ t('ELIXIO_CONNECT.EMAIL_MESSAGE') }}</label>
      <textarea
        v-model="form.email_message"
        class="ec-textarea"
        rows="3"
        :placeholder="t('ELIXIO_CONNECT.EMAIL_MESSAGE')"
      />
    </div>

    <!-- Section 3: Documents (template-based only) -->
    <div v-if="form.use_template && form.documents.length" class="ec-mb-3">
      <h6 class="ec-section-title">
        <i class="bi bi-file-earmark-copy" />
        {{ t('ELIXIO_CONNECT.MODEL_DOCUMENTS') }}
      </h6>
      <p class="ec-text-muted" style="font-size: 0.8125rem">
        {{ t('ELIXIO_CONNECT.YOU_CAN_CHANGE_DOCUMENTS') }}
      </p>
      <div
        v-for="(doc, index) in form.documents"
        :key="doc.id || index"
        class="ec-document-row"
      >
        <span class="ec-document-row__name">
          <i class="bi bi-file-earmark" />
          {{ doc.originalName }}
        </span>
        <div class="ec-document-row__actions">
          <template v-if="!doc.replacementFileName">
            <div style="display: contents">
              <label :for="'doc-replace-' + index" class="ec-btn-file">
                <i class="bi bi-upload" />
                {{ t('ELIXIO_CONNECT.SELECT_A_FILE') }}
              </label>
              <input
                :id="'doc-replace-' + index"
                type="file"
                style="display: none"
                accept=".pdf,.doc,.docx"
                @change="onDocumentReplace(index, $event)"
              />
            </div>
          </template>
          <template v-else>
            <div style="display: contents">
              <span class="ec-document-row__replacement" :title="doc.replacementFileName">
                <i class="bi bi-paperclip" />
                {{ doc.replacementFileName }}
              </span>
              <EcButton
                type="button"
                variant="outline-danger"
                size="sm"
                icon="x-lg"
                @click="removeReplacement(index)"
              />
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Section 3b: Fields payload (template with fields) -->
    <div v-if="hasFields" class="ec-mb-3">
      <h6 class="ec-section-title">
        <i class="bi bi-input-cursor-text" />
        {{ t('ELIXIO_CONNECT.DOCUMENTS_PAYLOAD') }}
      </h6>

      <div class="ec-fields-grid">
        <!-- TEXTFIELD -->
        <template v-for="field in getFieldsByType('TEXTFIELD')">
          <div :key="'text-' + field.code" class="ec-fields-grid__col">
            <EcInput
              :value="field.value"
              :label="(field.label || field.code) + (field.required ? ' (*)' : '')"
              :placeholder="field.code"
              :required="field.required"
              :error="getError('fields.' + fieldIndex(field) + '.value')"
              @input="field.value = $event"
            />
          </div>
        </template>

        <!-- LIST (select) -->
        <template v-for="field in getFieldsByType('LIST')">
          <div :key="'list-' + field.code" class="ec-fields-grid__col">
            <EcSelect
              :value="field.value"
              :label="(field.label || field.code) + (field.required ? ' (*)' : '')"
              :options="(field.options || []).map(function(o) { return { value: o, label: o } })"
              :placeholder="'Sélectionner'"
              :required="field.required"
              :error="getError('fields.' + fieldIndex(field) + '.value')"
              @input="field.value = $event"
            />
          </div>
        </template>
      </div>

      <!-- RADIO groups -->
      <template v-for="(group, gIdx) in getRadioGroups(form.fields)">
        <div :key="'radio-group-' + gIdx" class="ec-form-group ec-mb-2">
          <label class="ec-form-label">{{ group.groupTooltip }}</label>
          <div class="ec-radio-group">
            <label
              v-for="field in group.fields"
              :key="'radio-' + field.code"
              class="ec-radio"
              :class="{ 'ec-radio--checked': group.selected === field.code }"
            >
              <input
                type="radio"
                :name="'radio-group-' + gIdx"
                :value="field.code"
                :checked="group.selected === field.code"
                @change="handleRadioChange(group, field.code)"
              />
              {{ field.label }}
            </label>
          </div>
          <div v-if="getError('fields.' + fieldIndex(group.fields[0]) + '.value')" class="ec-form-error">
            {{ getError('fields.' + fieldIndex(group.fields[0]) + '.value') }}
          </div>
        </div>
      </template>

      <!-- CHECKBOX -->
      <template v-for="field in getFieldsByType('CHECKBOX')">
        <div :key="'cb-' + field.code" class="ec-mb-2">
          <EcCheckbox
            :value="field.value"
            :label="field.label || field.code"
            @input="field.value = $event"
          />
          <div v-if="getError('fields.' + fieldIndex(field) + '.value')" class="ec-form-error">
            {{ getError('fields.' + fieldIndex(field) + '.value') }}
          </div>
        </div>
      </template>

      <!-- TEXTAREA -->
      <template v-for="field in getFieldsByType('TEXTAREA')">
        <div :key="'ta-' + field.code" class="ec-form-group ec-mb-2">
          <label class="ec-form-label">
            {{ field.label || field.code }}{{ field.required ? ' (*)' : '' }}
          </label>
          <textarea
            v-model="field.value"
            class="ec-textarea"
            rows="3"
            :placeholder="field.code"
          />
          <div v-if="getError('fields.' + fieldIndex(field) + '.value')" class="ec-form-error">
            {{ getError('fields.' + fieldIndex(field) + '.value') }}
          </div>
        </div>
      </template>
    </div>

    <!-- Section 4: Signers -->
    <div class="ec-mb-3">
      <div class="ec-flex ec-justify-between ec-items-center ec-mb-2">
        <h6 class="ec-section-title" style="margin: 0">
          <i class="bi bi-people" />
          {{ t('ELIXIO_CONNECT.SIGNERS') }}
        </h6>
        <EcButton
          v-if="canModifySigners"
          type="button"
          variant="outline-primary"
          size="sm"
          icon="plus-lg"
          @click="addSigner"
        >
          {{ t('ELIXIO_CONNECT.ADD_SIGNER') }}
        </EcButton>
      </div>

      <div v-if="getError('signers')" class="ec-form-error ec-mb-2">
        {{ getError('signers') }}
      </div>
      <div v-if="getError('roles')" class="ec-form-error ec-mb-2">
        {{ getError('roles') }}
      </div>

      <div
        v-for="(signer, index) in form.signers"
        :key="index"
        class="ec-signer-form"
      >
        <div v-if="form.signers.length > 1 && canModifySigners" class="ec-signer-form__delete">
          <EcButton
            type="button"
            variant="outline-danger"
            size="sm"
            icon="trash"
            @click="removeSigner(index)"
          />
        </div>
        <div class="ec-signer-form__grid">
          <div class="ec-signer-form__field">
            <EcComboSelect
              :value="signer.role"
              :label="index === 0 ? t('ELIXIO_CONNECT.ROLE') : undefined"
              :placeholder="t('ELIXIO_CONNECT.ROLE')"
              :disabled="usingOneSpanModel || isEditMode"
              :options="roleOptions"
              :error="getError('signers.' + index + '.role')"
              allow-create
              @input="signer.role = $event; onRoleChange(signer)"
            />
          </div>
          <div class="ec-signer-form__field">
            <EcInput
              :value="signer.email"
              type="email"
              :label="index === 0 ? t('ELIXIO_CONNECT.EMAIL') : undefined"
              :placeholder="t('ELIXIO_CONNECT.EMAIL')"
              required
              :error="getError('signers.' + index + '.email')"
              @input="signer.email = $event"
            />
          </div>
          <div class="ec-signer-form__field">
            <EcInput
              :value="signer.first_name"
              :label="index === 0 ? t('ELIXIO_CONNECT.FIRSTNAME') : undefined"
              :placeholder="t('ELIXIO_CONNECT.FIRSTNAME')"
              :error="getError('signers.' + index + '.first_name')"
              @input="signer.first_name = $event"
            />
          </div>
          <div class="ec-signer-form__field">
            <EcInput
              :value="signer.last_name"
              :label="index === 0 ? t('ELIXIO_CONNECT.LASTNAME') : undefined"
              :placeholder="t('ELIXIO_CONNECT.LASTNAME')"
              :error="getError('signers.' + index + '.last_name')"
              @input="signer.last_name = $event"
            />
          </div>
        </div>
        <div class="ec-signer-form__address">
          <EcInput
            :value="signer.address"
            :label="index === 0 ? t('ELIXIO_CONNECT.ADDRESS') : undefined"
            :placeholder="t('ELIXIO_CONNECT.ADDRESS')"
            :error="getError('signers.' + index + '.address')"
            @input="signer.address = $event"
          />
        </div>
      </div>
    </div>

    <!-- Section 5: Send Now Option (OneSpan model, create mode only) -->
    <div v-if="showSendNow" class="ec-mb-3">
      <EcCheckbox
        :value="form.send_immediately"
        :label="t('ELIXIO_CONNECT.SEND_FOR_SIGNATURE')"
        @input="form.send_immediately = $event"
      />
    </div>

    <!-- Section 6: Action Buttons -->
    <div class="ec-flex ec-justify-end ec-gap-2 ec-mt-4">
      <EcButton type="button" variant="secondary" @click="onCancel">
        {{ t('ELIXIO_CONNECT.CANCEL') }}
      </EcButton>
      <EcButton type="submit" variant="primary" :disabled="submitting">
        <EcSpinner v-if="submitting" size="sm" style="margin-right: 0.25rem" />
        {{ isEditMode ? t('ELIXIO_CONNECT.EDIT_SIGNATURE') : t('ELIXIO_CONNECT.ADD_SIGNATURE') }}
      </EcButton>
    </div>
  </form>
</template>

<style scoped>
.ec-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.ec-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ec-text-color, #1f2937);
}

.ec-document-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.625rem 0.875rem;
  margin-bottom: 0.5rem;
  background: var(--ec-bg-muted, #f8f9fa);
  border: 1px solid var(--ec-border-color, #e2e8f0);
  border-radius: 8px;
}

.ec-document-row__name {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  flex: 1;
  min-width: 0;
  font-weight: 600;
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ec-document-row__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.ec-document-row__replacement {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8125rem;
  color: var(--ec-primary, #3b82f6);
}

.ec-btn-file {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--ec-primary, #3b82f6);
  border: 1px solid var(--ec-primary, #3b82f6);
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;
}

.ec-btn-file:hover {
  background: rgba(59, 130, 246, 0.06);
}

.ec-signer-form {
  position: relative;
  padding: 0.875rem;
  margin-bottom: 0.75rem;
  background: var(--ec-bg-muted, #f8f9fa);
  border: 1px solid var(--ec-border-color, #e2e8f0);
  border-radius: 8px;
}

.ec-signer-form__delete {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}

.ec-signer-form__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.ec-signer-form__address {
  margin-top: 0.75rem;
}

.ec-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.ec-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.ec-radio {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
  cursor: pointer;
  color: var(--ec-text-color, #1f2937);
}

.ec-radio input[type="radio"] {
  accent-color: var(--ec-primary, #3b82f6);
}

.ec-radio--checked {
  font-weight: 600;
  color: var(--ec-primary, #3b82f6);
}

@media (max-width: 640px) {
  .ec-form-row,
  .ec-signer-form__grid,
  .ec-fields-grid {
    grid-template-columns: 1fr;
  }
}
</style>
